import { render, staticRenderFns } from "./UsuarioFornecedorConfiguracoesAcessoRepresentanteLegalForm.vue?vue&type=template&id=17a777de&scoped=true&lang=html"
import script from "./UsuarioFornecedorConfiguracoesAcessoRepresentanteLegalForm.vue?vue&type=script&lang=js"
export * from "./UsuarioFornecedorConfiguracoesAcessoRepresentanteLegalForm.vue?vue&type=script&lang=js"
import style0 from "./UsuarioFornecedorConfiguracoesAcessoRepresentanteLegalForm.vue?vue&type=style&index=0&id=17a777de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a777de",
  null
  
)

export default component.exports